import css from '@/components/ui/shared/Table/cells/CountCell.module.css';

interface Props {
  total: number;
  /** When > 0, renders the brand-colored unread pill before the total. */
  unread?: number;
}

export function CountCell({ total, unread = 0 }: Props) {
  return (
    <span className={css.count}>
      {unread > 0 && (
        <>
          <span className={css.unreadMark}>{unread}</span>
          <span>{' / '}</span>
        </>
      )}
      {total}
    </span>
  );
}
